var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowsUpDown = function SvgArrowsUpDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.5 6 14.75m0 0L3.75 12.5M6 14.75V4.25M9.75 6.5 12 4.25m0 0 2.25 2.25M12 4.25v10.5"
  })));
};
export default SvgArrowsUpDown;